//Window Resize
function windowIsSmallerThan(width = 0,callbackToRun) {
    width > 0 && callbackToRun()
    return window.innerWidth < width
}

//Window resized
class ResizeHandler {
    constructor() {
        this.functions = [];
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize);
    }

    addFunction(fn) {
        if (typeof fn === 'function') {
            this.functions.push(fn);
        } else {
            console.error('Argument must be a function');
        }
    }

    handleResize() {
        this.functions.forEach(fn => fn());
    }
}

//Exports
export {windowIsSmallerThan, ResizeHandler}  
